import PropTypes from 'prop-types';
export const tooltipPropTypes = {
  /**
   * The node of a React component.
   */
  trigger: PropTypes.node.isRequired,
  /**
   * The children of a React component.
   */
  children: PropTypes.node.isRequired
};